import {
  ConfigurationDto,
  postSaveConfiguration,
  PrintExampleDto,
} from '@/api-sdk';
import {
  GlobalComponentType,
  personalisation,
  PersonalisationType,
  printExample,
} from '@/context';

/**
 * Saves the configuration and associated contexts, then executes a callback with the configuration ID.
 *
 * @param globalContext - The global context containing debtor, country, layout, and locale.
 * @param personalisationContext - Optional personalisation context array.
 * @param printExampleContext - Optional print example context.
 * @param configuration - The configuration data to be saved.
 * @param callback - The callback function to be executed with the configuration ID.
 */
export const saveConfiguration = async ({
  globalContext,
  personalisationContext,
  printExampleContext,
  configuration,
  callback,
}: {
  globalContext: GlobalComponentType;
  personalisationContext?: PersonalisationType[];
  printExampleContext?: PrintExampleDto;
  configuration: ConfigurationDto;
  callback: (configurationId: string) => void;
}) => {
  const { debtor, country, layout, locale } = globalContext;

  const configurationId = await postSaveConfiguration({
    params: {
      debtor: layout === 'wholesale' ? debtor : undefined,
      country,
    },
    data: configuration,
  });

  if (configurationId) {
    if (personalisationContext) {
      await personalisation.save(
        personalisationContext,
        configurationId,
        locale,
      );
    }
    if (printExample) {
      await printExample.save(printExampleContext, configurationId);
    }
    callback(configurationId);
  }
};
